export enum CruiseTopId {
    COSTA = 132,
    MSC = 113,
    AZAMARA = 6019,
    CELEBRITY = 6020,
    ROYAL = 6021,
    CARNIVAL = 183
}
